export default theme => {
  return {
    small: { fontSize: 25 },
    medium: { fontSize: 35 },
    large: { fontSize: 50 },
    xLarge: { fontSize: 75 }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/generic/Icon.js